var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RadioNavigation',_vm._b({},'RadioNavigation',_vm.funnelData,false))
}
var staticRenderFns = []

export { render, staticRenderFns }